import { render, staticRenderFns } from "./ExcelImportErrorsTable.vue?vue&type=template&id=a06c8b70"
import script from "./ExcelImportErrorsTable.vue?vue&type=script&lang=js"
export * from "./ExcelImportErrorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports